//import { Path } from '../routes'
import * as types from '../constants/Action_types'

const initialState = {
    reports: [],

}

export default function (state = initialState, action) {

    switch (action.type) {

        case types.GET_REPORTS:
            return {
                ...state,
                reports: action.payload
            }
        default:
            return state
    }
}
